module.exports = __webpack_public_path__ + "lv.svg?a27c9213e4257535b6d5a4ce1a38a572";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/lv.svg
// module id = 1061
// module chunks = 27